<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<div class="fm-title"><a id="page_3"></a><span class="big"><b>CONTENTS</b></span></div>
<div class="toc"><a href="#/05_Int"><span class="black"><b>Introduction</b></span></a></div>
<div class="toc1"><a href="#/06_Prologue"><span class="black"><b>Prologue</b></span></a></div>
<div class="toc"><a href="#/08_Chapter01"><span class="black"><b>CHAPTER 1: Before the Vikings</b></span></a></div>
<div class="toc"><span href="#/11_Chapter02" title="Link target outside of Sample"><span class="black"><b>CHAPTER 2: First Encounter</b></span></span></div>
<div class="toc"><span href="#/14_Chapter03" title="Link target outside of Sample"><span class="black"><b>CHAPTER 3: Here Come the Vikings</b></span></span></div>
<div class="toc"><span href="#/17_Chapter04" title="Link target outside of Sample"><span class="black"><b>CHAPTER 4: The Missions</b></span></span></div>
<div class="toc"><span href="#/19_Chapter05" title="Link target outside of Sample"><span class="black"><b>CHAPTER 5: After the Vikings</b></span></span></div>
<div class="toc"><span href="#/21_Chapter06" title="Link target outside of Sample"><span class="black"><b>CHAPTER 6: The Memories</b></span></span></div>
<div class="toc"><span href="#/24_Chapter07" title="Link target outside of Sample"><span class="black"><b>CHAPTER 7: A Mystery That Lingers</b></span></span></div>
<div class="toc"><span href="#/27_Appendix01" title="Link target outside of Sample"><span class="black"><b>APPENDIXES</b></span></span></div>
<div class="toc1"><span href="#/27_Appendix01#app" title="Link target outside of Sample"><span class="black"><b>Appendix 1: Selected Chronology from the “Pentagon Papers,” 1963–64</b></span></span></div>
<div class="toc1"><span href="#/28_Appendix02" title="Link target outside of Sample"><span class="black"><b>Appendix 2: The “Viking Ships”: The Nasty Boats, Swift Boats, and the <i>Marjata</i> Spy Ship</b></span></span></div>
<div class="toc"><span href="#/29_Biographical" title="Link target outside of Sample"><span class="black"><b>Biographical Notes: Americans, Norwegians, and Vietnamese</b></span></span></div>
<div class="toc1"><span href="#/30_Source" title="Link target outside of Sample"><span class="black"><b>Bibliography and Sources</b></span></span></div>
<div class="toc1"><span href="#/31_Ack" title="Link target outside of Sample"><span class="black"><b>Acknowledgments</b></span></span></div>
<div class="toc1"><span href="#/32_Index" title="Link target outside of Sample"><span class="black"><b>Index</b></span></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?da6e886c